module.exports = __webpack_public_path__ + "static/media/Oct8-F18.bfa4143a.png";